var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BCXCollapsible',{staticClass:"bc-my-recommendations-table-feedback bcx-table__full-width",attrs:{"is-opened":_vm.isOpened}},[_c('FeedbackDetails',{staticClass:"c-feedback-details",attrs:{"is-feedback":"","project":_vm.project,"recommendation":_vm.recommendation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }